import {
  PORTFOLIOS_CHANGED,
  PORTFOLIOS_SELECTED,
  PORTFOLIOS_LOGOUT
} from '../../const/actionsType';

import { dates } from 'investira.sdk';

const INITIAL_STATE = {
  data: [],
  current: {},
  updatedAt: dates.toDate()
};

const RESET_STATE = {
  ...INITIAL_STATE
};

function portfoliosReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case PORTFOLIOS_CHANGED:
      return {
        ...state,
        data: action.payload,
        updatedAt: dates.toDate()
      };
    case PORTFOLIOS_SELECTED:
      return {
        ...state,
        current: action.payload
      };
    case PORTFOLIOS_LOGOUT:
      return {
        ...RESET_STATE
      };
    default:
      return state;
  }
}

export default portfoliosReducer;
